import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;
export const configured = !!(url && anon);

/** The company the person is working in. Sent as x-tenant-id on every request (RLS reads it). */
let tenant: string | null = null;
export const setTenantHeader = (id: string | null) => { tenant = id; };
export const tenantHeader = () => tenant;

const withTenant: typeof fetch = (input, init = {}) => {
  const h = new Headers(init.headers);
  if (tenant) h.set('x-tenant-id', tenant);
  else h.delete('x-tenant-id');
  return fetch(input, { ...init, headers: h });
};

export const sb = createClient(url || 'https://not-configured.invalid', anon || 'not-configured', {
  auth: { storageKey: 'xr-web-auth', persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, flowType: 'pkce' },
  global: { fetch: withTenant },
});

/** A database refusal as its code (e.g. `not_allowed`, `trn_invalid`), or a network failure. */
export class DbError extends Error {
  constructor(public code: string, message?: string) { super(message || code); }
}

export async function rpc<T = unknown>(fn: string, args: Record<string, unknown> = {}): Promise<T> {
  const { data, error } = await sb.rpc(fn, args);
  if (error) throw new DbError(error.message && /^[a-z_]+$/.test(error.message) ? error.message : (error.code || 'network'), error.message);
  return data as T;
}
